import { keyValueStorage } from './defaultKeyValueStorage';

export const useKeyValueStorageItem = (
  name: string,
  defaultValue: string | undefined,
): string | undefined => {
  const itemFromLS = keyValueStorage.getItem(name);

  if (itemFromLS === undefined && defaultValue !== undefined) {
    keyValueStorage.setItem(name, defaultValue);
    return defaultValue;
  }

  return itemFromLS;
};
